import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';

import styles from './_styles/ImportComplete.module.scss';

const allActionCreators = Object.assign({});

export class ImportComplete extends Component {

	render() {
		return <div className={styles.ImportComplete}>
			<div className={styles.completeWrapper}>
				<div className={styles.copy}>Import Complete!</div>
				<div className={styles.actionWrapper}>
					<Link to={'/ddny/gallery'}>
						<button type='button' className={`${styles.action} actionButton`}>
							View
						</button>
					</Link>
				</div>
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(ImportComplete);